import { useState } from 'react';

import { TrashIcon } from 'icons';
import type { BoardInvitationV2Type } from 'types';

import { InvitationDeleteModal } from './InvitationDeleteModal';

type Props = {
  invitation: BoardInvitationV2Type;
};

export const InvitationDelete = ({ invitation }: Props) => {
  const [modalOpened, setModalOpened] = useState(false);

  return (
    <>
      <TrashIcon
        color="red"
        sx={{ cursor: 'pointer' }}
        onClick={() => setModalOpened(true)}
      />
      <InvitationDeleteModal
        opened={modalOpened}
        onClose={() => setModalOpened(false)}
        invitationId={invitation.id}
      />
    </>
  );
};
